import { FormApi } from '@theme/form-api';


class SubscribeDrop extends FormApi {
  /**
   * Handles the success event for the form.
   *
   * @param {Response} response - The response from the form.
   */
  onSuccess = async (response) => {
    const data = await this.parseResponse(response);
    this.refs.form.hidden = true;
    this.refs.error.hidden = true;

    const { step1, step2Members, step2NotMembers } = /** @type {any} */ (this.refs);
    if(step1) step1.hidden = true;
    if(data.member && step2Members) step2Members.hidden = false;
    if(!data.member && step2NotMembers) step2NotMembers.hidden = false;
  }
}

if (!customElements.get('subscribe-drop')) {
  customElements.define('subscribe-drop', SubscribeDrop);
}
